var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "user-page-tab" } },
    [
      _c(
        "b-dropdown",
        {
          staticClass: "m-md-2",
          attrs: {
            id: "dropdown-1",
            variant: "primary",
            text: "Pilih Jenis Pengguna"
          }
        },
        [
          _c(
            "b-dropdown-item",
            {
              attrs: {
                active: _vm.$route.name === "Daftar Owner",
                href: "#/pengaturan/pengguna/owner"
              }
            },
            [_vm._v("Owner")]
          ),
          _vm._v(" "),
          _c(
            "b-dropdown-item",
            {
              attrs: {
                active: _vm.$route.name === "Daftar Kasir",
                href: "#/pengaturan/pengguna/kasir"
              }
            },
            [_vm._v("Kasir")]
          ),
          _vm._v(" "),
          _c(
            "b-dropdown-item",
            {
              attrs: {
                active: _vm.$route.name === "Daftar Gudang",
                href: "#/pengaturan/pengguna/gudang"
              }
            },
            [_vm._v("Gudang")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21acc009", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21acc009","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Settings/Users/Index.vue
// module id = 3qNB
// module chunks = 4